// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.data-flow-container {
  width: 100%;
  overflow-x: auto;
  padding: 20px 0;
}

#data-flow-container canvas {
  display: block;
  margin: 0 auto;
}

.data-flow-diagram {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 1100px;
  height: 500px;
  position: relative;
  margin: 0 auto;
}

.node-group {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
}

.node-group.sources {
  width: 150px;
}

.node-group.database {
  width: 150px;
}

.node-group.engines {
  width: 150px;
}

.node-group.glowytics {
  width: 150px;
}

.node-group.channels {
  width: 150px;
}

.node {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px 0;
}

/* Logo styles */
.node-logo {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: white;
  border: 2px solid #ddd;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  transition: all 0.3s ease;
  z-index: 2;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.node-logo.database-logo {
  width: 100px;
  height: 100px;
  position: relative;
}

.logo-image {
  max-width: 80%;
  max-height: 80%;
  object-fit: contain;
}

.logo-image.large {
  max-width: 90%;
  max-height: 90%;
}

.logo-label {
  position: absolute;
  bottom: -25px;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

/* Original circle styles for non-logo nodes */
.node-circle {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: white;
  border: 2px solid;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 10px;
  font-weight: bold;
  transition: all 0.3s ease;
  z-index: 2;
}

.node-circle.medium {
  width: 80px;
  height: 80px;
  font-size: 12px;
}

.node-circle.large {
  width: 100px;
  height: 100px;
  font-size: 14px;
}

.node.active .node-circle,
.node.active .node-logo {
  box-shadow: 0 0 15px rgba(59, 130, 246, 0.7);
  border-color: #3B82F6;
}

/* Data lines */
.data-line {
  position: absolute;
  height: 2px;
  background-color: #333;
  z-index: 1;
}

/* Source to Database lines - UPDATED */
.node.source:nth-child(1) .data-line {
  width: 190px;
  top: 30px;
  left: 30px;
  transform: rotate(20deg);
  transform-origin: left center;
}

.node.source:nth-child(2) .data-line {
  width: 170px;
  top: 30px;
  left: 30px;
  transform: rotate(10deg);
  transform-origin: left center;
}

.node.source:nth-child(3) .data-line {
  width: 170px;
  top: 30px;
  left: 30px;
  transform: rotate(-10deg);
  transform-origin: left center;
}

.node.source:nth-child(4) .data-line {
  width: 190px;
  top: 30px;
  left: 30px;
  transform: rotate(-20deg);
  transform-origin: left center;
}

/* Database to Engine lines */
.node.database .data-line.to-engine1 {
  width: 150px;
  top: -30px;
  left: 100px;
  transform: rotate(-15deg);
  transform-origin: left center;
}

.node.database .data-line.to-engine2 {
  width: 150px;
  top: 30px;
  left: 100px;
  transform: rotate(15deg);
  transform-origin: left center;
}

/* Engine to Glowytics lines */
.node.engine .data-line {
  width: 150px;
  top: 40px;
  left: 80px;
  transform-origin: left center;
}

/* Glowytics to Channel lines */
.node.glowytics .data-line.to-channel1 {
  width: 150px;
  top: -60px;
  left: 100px;
  transform: rotate(-30deg);
  transform-origin: left center;
}

.node.glowytics .data-line.to-channel2 {
  width: 150px;
  top: -20px;
  left: 100px;
  transform: rotate(-10deg);
  transform-origin: left center;
}

.node.glowytics .data-line.to-channel3 {
  width: 150px;
  top: 20px;
  left: 100px;
  transform: rotate(10deg);
  transform-origin: left center;
}

.node.glowytics .data-line.to-channel4 {
  width: 150px;
  top: 60px;
  left: 100px;
  transform: rotate(30deg);
  transform-origin: left center;
}

/* Animation for data flow */
.data-line.animate::after {
  content: '';
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #3B82F6;
  top: -3px;
  left: 0;
  animation: moveData 1s linear forwards;
}

@keyframes moveData {
  0% {
    left: 0;
  }
  100% {
    left: 100%;
  }
}

/* Responsive adjustments */
@media (max-width: 1200px) {
  .data-flow-diagram {
    min-width: 900px;
  }
  
  .node-group {
    width: 120px;
  }
  
  .data-line {
    width: 120px;
  }
}

@media (max-width: 992px) {
  .data-flow-diagram {
    min-width: 800px;
  }
  
  .node-group {
    width: 100px;
  }
  
  .data-line {
    width: 100px;
  }
}

/* Cool diagram styles */
.cool-diagram-container {
  margin-bottom: 3rem;
  overflow-x: auto;
}

.cool-diagram {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  min-width: 1100px;
}

.node-text {
  font-size: 14px;
  fill: #4b5563;
  font-weight: 500;
}

.node-emoji {
  font-size: 24px;
  fill: currentColor;
}

.node-group:hover .node-circle {
  filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1));
  transform: scale(1.05);
  transition: all 0.3s ease;
}

.node-group:hover .node-icon {
  transform: scale(1.1);
  transition: all 0.3s ease;
}

/* Animations */
@keyframes drawLine {
  from {
    stroke-dashoffset: 1000;
  }
  to {
    stroke-dashoffset: 0;
  }
}

@keyframes popIn {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  70% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.4;
  }
  100% {
    transform: scale(1);
    opacity: 0.8;
  }
}

.path-line {
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
}

.animate-draw {
  animation: drawLine 2s ease-in-out forwards;
}

.animate-pop {
  transform-origin: center;
  animation: popIn 0.6s ease-out forwards;
  opacity: 0;
}

.animate-fade-in {
  opacity: 0;
  animation: fadeIn 0.8s ease-out forwards;
}

.animate-pulse {
  animation: pulse 2s ease-in-out infinite;
}

.moving-dot {
  opacity: 0;
}

.animate-move {
  opacity: 0.9;
} `, "",{"version":3,"sources":["webpack://./src/components/DataFlowAnimation.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA,8CAA8C;AAC9C;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,UAAU;AACZ;;AAEA,uCAAuC;AACvC;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,6BAA6B;AAC7B;EACE,YAAY;EACZ,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,WAAW;EACX,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA,8BAA8B;AAC9B;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,6BAA6B;AAC/B;;AAEA,+BAA+B;AAC/B;EACE,YAAY;EACZ,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,WAAW;EACX,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,WAAW;EACX,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;EACT,OAAO;EACP,sCAAsC;AACxC;;AAEA;EACE;IACE,OAAO;EACT;EACA;IACE,UAAU;EACZ;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,wIAAwI;EACxI,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iDAAiD;EACjD,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,YAAY;EACd;AACF;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;EACxB,uCAAuC;EACvC,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd","sourcesContent":[".data-flow-container {\n  width: 100%;\n  overflow-x: auto;\n  padding: 20px 0;\n}\n\n#data-flow-container canvas {\n  display: block;\n  margin: 0 auto;\n}\n\n.data-flow-diagram {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  min-width: 1100px;\n  height: 500px;\n  position: relative;\n  margin: 0 auto;\n}\n\n.node-group {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  height: 100%;\n}\n\n.node-group.sources {\n  width: 150px;\n}\n\n.node-group.database {\n  width: 150px;\n}\n\n.node-group.engines {\n  width: 150px;\n}\n\n.node-group.glowytics {\n  width: 150px;\n}\n\n.node-group.channels {\n  width: 150px;\n}\n\n.node {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 10px 0;\n}\n\n/* Logo styles */\n.node-logo {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  background-color: white;\n  border: 2px solid #ddd;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  transition: all 0.3s ease;\n  z-index: 2;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.node-logo.database-logo {\n  width: 100px;\n  height: 100px;\n  position: relative;\n}\n\n.logo-image {\n  max-width: 80%;\n  max-height: 80%;\n  object-fit: contain;\n}\n\n.logo-image.large {\n  max-width: 90%;\n  max-height: 90%;\n}\n\n.logo-label {\n  position: absolute;\n  bottom: -25px;\n  left: 0;\n  right: 0;\n  text-align: center;\n  font-size: 14px;\n  font-weight: bold;\n  color: #333;\n}\n\n/* Original circle styles for non-logo nodes */\n.node-circle {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  background-color: white;\n  border: 2px solid;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-size: 10px;\n  font-weight: bold;\n  transition: all 0.3s ease;\n  z-index: 2;\n}\n\n.node-circle.medium {\n  width: 80px;\n  height: 80px;\n  font-size: 12px;\n}\n\n.node-circle.large {\n  width: 100px;\n  height: 100px;\n  font-size: 14px;\n}\n\n.node.active .node-circle,\n.node.active .node-logo {\n  box-shadow: 0 0 15px rgba(59, 130, 246, 0.7);\n  border-color: #3B82F6;\n}\n\n/* Data lines */\n.data-line {\n  position: absolute;\n  height: 2px;\n  background-color: #333;\n  z-index: 1;\n}\n\n/* Source to Database lines - UPDATED */\n.node.source:nth-child(1) .data-line {\n  width: 190px;\n  top: 30px;\n  left: 30px;\n  transform: rotate(20deg);\n  transform-origin: left center;\n}\n\n.node.source:nth-child(2) .data-line {\n  width: 170px;\n  top: 30px;\n  left: 30px;\n  transform: rotate(10deg);\n  transform-origin: left center;\n}\n\n.node.source:nth-child(3) .data-line {\n  width: 170px;\n  top: 30px;\n  left: 30px;\n  transform: rotate(-10deg);\n  transform-origin: left center;\n}\n\n.node.source:nth-child(4) .data-line {\n  width: 190px;\n  top: 30px;\n  left: 30px;\n  transform: rotate(-20deg);\n  transform-origin: left center;\n}\n\n/* Database to Engine lines */\n.node.database .data-line.to-engine1 {\n  width: 150px;\n  top: -30px;\n  left: 100px;\n  transform: rotate(-15deg);\n  transform-origin: left center;\n}\n\n.node.database .data-line.to-engine2 {\n  width: 150px;\n  top: 30px;\n  left: 100px;\n  transform: rotate(15deg);\n  transform-origin: left center;\n}\n\n/* Engine to Glowytics lines */\n.node.engine .data-line {\n  width: 150px;\n  top: 40px;\n  left: 80px;\n  transform-origin: left center;\n}\n\n/* Glowytics to Channel lines */\n.node.glowytics .data-line.to-channel1 {\n  width: 150px;\n  top: -60px;\n  left: 100px;\n  transform: rotate(-30deg);\n  transform-origin: left center;\n}\n\n.node.glowytics .data-line.to-channel2 {\n  width: 150px;\n  top: -20px;\n  left: 100px;\n  transform: rotate(-10deg);\n  transform-origin: left center;\n}\n\n.node.glowytics .data-line.to-channel3 {\n  width: 150px;\n  top: 20px;\n  left: 100px;\n  transform: rotate(10deg);\n  transform-origin: left center;\n}\n\n.node.glowytics .data-line.to-channel4 {\n  width: 150px;\n  top: 60px;\n  left: 100px;\n  transform: rotate(30deg);\n  transform-origin: left center;\n}\n\n/* Animation for data flow */\n.data-line.animate::after {\n  content: '';\n  position: absolute;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: #3B82F6;\n  top: -3px;\n  left: 0;\n  animation: moveData 1s linear forwards;\n}\n\n@keyframes moveData {\n  0% {\n    left: 0;\n  }\n  100% {\n    left: 100%;\n  }\n}\n\n/* Responsive adjustments */\n@media (max-width: 1200px) {\n  .data-flow-diagram {\n    min-width: 900px;\n  }\n  \n  .node-group {\n    width: 120px;\n  }\n  \n  .data-line {\n    width: 120px;\n  }\n}\n\n@media (max-width: 992px) {\n  .data-flow-diagram {\n    min-width: 800px;\n  }\n  \n  .node-group {\n    width: 100px;\n  }\n  \n  .data-line {\n    width: 100px;\n  }\n}\n\n/* Cool diagram styles */\n.cool-diagram-container {\n  margin-bottom: 3rem;\n  overflow-x: auto;\n}\n\n.cool-diagram {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n  min-width: 1100px;\n}\n\n.node-text {\n  font-size: 14px;\n  fill: #4b5563;\n  font-weight: 500;\n}\n\n.node-emoji {\n  font-size: 24px;\n  fill: currentColor;\n}\n\n.node-group:hover .node-circle {\n  filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1));\n  transform: scale(1.05);\n  transition: all 0.3s ease;\n}\n\n.node-group:hover .node-icon {\n  transform: scale(1.1);\n  transition: all 0.3s ease;\n}\n\n/* Animations */\n@keyframes drawLine {\n  from {\n    stroke-dashoffset: 1000;\n  }\n  to {\n    stroke-dashoffset: 0;\n  }\n}\n\n@keyframes popIn {\n  0% {\n    transform: scale(0);\n    opacity: 0;\n  }\n  70% {\n    transform: scale(1.1);\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n    opacity: 0.8;\n  }\n  50% {\n    transform: scale(1.05);\n    opacity: 0.4;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 0.8;\n  }\n}\n\n.path-line {\n  stroke-dasharray: 1000;\n  stroke-dashoffset: 1000;\n}\n\n.animate-draw {\n  animation: drawLine 2s ease-in-out forwards;\n}\n\n.animate-pop {\n  transform-origin: center;\n  animation: popIn 0.6s ease-out forwards;\n  opacity: 0;\n}\n\n.animate-fade-in {\n  opacity: 0;\n  animation: fadeIn 0.8s ease-out forwards;\n}\n\n.animate-pulse {\n  animation: pulse 2s ease-in-out infinite;\n}\n\n.moving-dot {\n  opacity: 0;\n}\n\n.animate-move {\n  opacity: 0.9;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
